import React from 'react'

import { useSelector, useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'

import { Loader } from '@/components/loaders/Loader'
import { createEntry, updateEntry } from '@/reducers/playbooks/playbook.redux'
import { fetchPlaybookSectionWarnings } from '@/reducers/playbooks/playbook.actions'
import NoData from '@/components/NoData'

import { accessorSectionMap } from '../playbook.helpers'

export const PlaybookEditor = ({ entry, children, categoryId }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { entryId, section, id } = useParams()
  const {
    loading,
    playbook: { current: isLatestPlaybookVersion },
  } = useSelector((state) => state.playbook)
  const { edit_config } = useSelector((state) => state.currentUser)
  const accessor = accessorSectionMap[section]
  const isCreate = entryId === 'create'
  const readOnly = !isLatestPlaybookVersion || !edit_config

  const handleUpdate = (updatedEntry) => {
    const valueToSend = { entry: updatedEntry }

    if (categoryId) {
      valueToSend.categoryId = categoryId
    }

    if (isCreate) {
      dispatch(createEntry(accessor)(valueToSend))
    } else {
      dispatch(updateEntry(accessor)({ entryId, ...valueToSend }))
    }

    history.push(`/playbooks/${id}/${section}`)
    dispatch(fetchPlaybookSectionWarnings(accessor))
  }

  const handleCancel = () => {
    history.push(`/playbooks/${id}/${section}`)
    dispatch(fetchPlaybookSectionWarnings(accessor))
  }

  if (loading.playbook) {
    return <Loader centered />
  }

  if (!isCreate && !entry) {
    return <NoData text="No item was found for this entry" position="left" />
  }

  return children({ handleUpdate, handleCancel, readOnly })
}
